import React from 'react';
import CircleExclamationPoint from '@uber/base-icons/circle-exclamation-point';
import { styled } from 'baseui';
import { Banner } from 'baseui/banner';
import { SIZE, StyledDivider } from 'baseui/divider';
import type { DynamicAttributeT, RelationshipAttributeT, ReviewAnnotationAttributesT as AttributesT, ReviewClassificationT as ClassificationAttributeT } from '../types';
import { AttributeItem } from './attribute-item';
import { RelationshipAttributeItem } from './relationship-attribute-item';
type Props = {
  attributes: AttributesT;
  isAttributeExpanded: boolean;
};
type AttributeT = ClassificationAttributeT | DynamicAttributeT | RelationshipAttributeT;
export const ContainerWrapper = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: `${$theme.sizing.scale500} 0`
}));
const Container = styled('div', ({
  $theme
}) => ({
  border: `${$theme.sizing.scale0} solid ${$theme.colors.borderOpaque}`,
  borderRadius: $theme.borders.radius200,
  padding: $theme.sizing.scale500
}));
const bannerArtwork = ({
  size
}: {
  size: string;
}) => <CircleExclamationPoint size={size} />;
const shouldShowDivider = (precedingGroups: AttributeT[][], index: number): boolean => precedingGroups.some(group => group.length > 0) || index > 0;
export const AttributeContainer = ({
  attributes,
  isAttributeExpanded
}: Props) => {
  const {
    classificationAttributes = [],
    dynamicAttributes = [],
    relationshipAttributes = []
  } = attributes || {};
  const shouldRenderNoAttributesBanner = classificationAttributes.length === 0 && dynamicAttributes.length === 0 && relationshipAttributes.length === 0;
  return <ContainerWrapper>
      {shouldRenderNoAttributesBanner ? <Banner artwork={{
      icon: bannerArtwork
    }} overrides={{
      Root: {
        style: {
          margin: 0
        }
      }
    }}>
          This object type does not require any attribute input.
        </Banner> : <Container>
          {classificationAttributes && classificationAttributes.map(({
        question,
        answers
      }, index) => <React.Fragment key={index}>
                <AttributeItem header={question} content={answers.join(', ')} isExpanded={isAttributeExpanded} />

                {index !== classificationAttributes!.length - 1 && <StyledDivider $size={SIZE.cell} $style={{
          width: '100%'
        }} />}
              </React.Fragment>)}
          {dynamicAttributes && dynamicAttributes.map(({
        key,
        value
      }, index) => <React.Fragment key={index}>
                {shouldShowDivider([classificationAttributes], index) && <StyledDivider $size={SIZE.cell} $style={{
          width: '100%'
        }} />}

                <AttributeItem header={key} content={value} />
              </React.Fragment>)}
          {relationshipAttributes.map((rel, index) => <React.Fragment key={index}>
              {shouldShowDivider([classificationAttributes, dynamicAttributes], index) && <StyledDivider $size={SIZE.cell} $style={{
          width: '100%'
        }} />}
              <RelationshipAttributeItem {...rel} />
            </React.Fragment>)}
        </Container>}
    </ContainerWrapper>;
};